import api from './index'
import type { ApiResponse, Activity } from '@/types'

// 取得議題的所有活動記錄
export const getActivities = async (issueId: string): Promise<ApiResponse<{ activities: Activity[] }>> => {
  const response = await api.get(`/activities/${issueId}`)
  return response.data
}

// 取得專案的所有活動記錄
export const getProjectActivities = async (
  projectId: string,
  params?: {
    startDate?: string
    endDate?: string
    type?: string
    userId?: string
    page?: number
    limit?: number
  }
): Promise<ApiResponse<{ activities: Activity[], total: number }>> => {
  const response = await api.get(`/projects/${projectId}/activities`, { params })
  return response.data
}

// 取得使用者的活動記錄
export const getUserActivities = async (
  userId?: string,
  params?: {
    startDate?: string
    endDate?: string
    type?: string
    projectId?: string
    page?: number
    limit?: number
  }
): Promise<ApiResponse<{ activities: Activity[], total: number }>> => {
  const url = userId ? `/users/${userId}/activities` : '/activities'
  const response = await api.get(url, { params })
  return response.data
}